import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import { AppSettingsNav } from '../common/ui/AppSettingsNav';
import { AppConfigTab } from './appConfig/AppConfigTab';

export class AppConfiguration extends Component {
  static propTypes = {
    appSetting: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  componentDidMount() {
    const { match, actions } = this.props;
    const { projectId, version } = match.params;
    actions.loadProjectDetailAppSetting({ projectId, version });
  }
  render() {
    const { appSetting, actions, match } = this.props;
    const { projectDetail } = appSetting;
    if (!projectDetail) {
      return '';
    }
    const { dateFormat } = projectDetail;
    const { projectId, version } = match.params;
    return (
      <CommonPageComponent>
        <AppSettingsNav activeTab={'appConfig'} projectDetail={projectDetail} />
        <AppConfigTab
          projectId={projectId}
          dateFormat={dateFormat}
          updateDateFormat={actions.updateDateFormat}
          version={version}
          toggle={this.toggle}
          actions={actions}
        />
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    appSetting: state.appSetting,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AppConfiguration);
